import React, { Component } from "react";
import Content from "../../content/Content";

export default class DisplayValidationErrorsMfa extends Component {
  render() {


return (
      <React.Fragment>
        {this.props.errors && this.props.errors.length > 0 ? (

          
          <div className="alertMfa alertMfaError">
            <p1 >
              <strong>{this.props.heading}</strong>
            </p1>
            
            <ul className="ulMfa">
              {this.props.errors.map((message, index) => (
                <li key={index}>
                  <Content name={message} />
                </li>
              ))}
            </ul>
          </div>
        ) : (
          ""
        )}
      </React.Fragment>
    );

    
    
  }
}
